import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import './ContactInfo.scss';
import Images from '../../Assets/Images/Images';
import { AiOutlineWhatsApp } from 'react-icons/ai';
import { GrMail } from 'react-icons/gr';
import { FaPhoneAlt } from 'react-icons/fa';
import { FcGoogle } from 'react-icons/fc';

const ContactInfo = () => {
  return (
    <div className='contact'>
      <Container>
        <h1 className='contact__title'>Tertarik untuk tinggal bersama kami? Punya pertanyaan? Ingin membuat janji?</h1>
        <Row>
          <Col lg={6}>
            <div className='contact__link-wrapper'>
              <Row>
                <Col>
                  <div
                    className='contact__info contact__info--not-link'
                  >
                    <div className='contact__icon-wrapper'>
                      <GrMail className='contact__icon' />
                    </div>
                    <p className='contact__text-wrapper'>
                      houseofarie@gmail.com
                    </p>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <a
                    className='contact__info'
                    target='_blank'
                    rel='noreferrer'
                    href='tel:6285780306440'
                  >
                    <div className='contact__icon-wrapper'>
                      <FaPhoneAlt className='contact__icon' />
                    </div>
                    <p className='contact__text-wrapper'>
                      +62 857-8030-6440
                    </p>
                  </a>
                </Col>
              </Row>
              <Row>
                <Col>
                  <a
                    className='contact__info'
                    target='_blank'
                    rel='noreferrer'
                    href='https://wa.me/6285780306440?text=Hi,%20saya%20ingin%20bertanya%20tentang%20House%20of%20Arie'
                  >
                    <div className='contact__icon-wrapper'>
                      <AiOutlineWhatsApp className='contact__icon' />
                    </div>
                    <p className='contact__text-wrapper'>
                      WhatsApp
                    </p>
                  </a>
                </Col>
              </Row>
              <Row>
                <Col>
                  <a
                    className='contact__info'
                    target='_blank'
                    rel='noreferrer'
                    href='https://g.page/kost-arie/review?gm'
                  >
                    <div className='contact__icon-wrapper'>
                      <FcGoogle className='contact__icon' />
                    </div>
                    <p className='contact__text-wrapper'>
                      Review us on Google
                    </p>
                  </a>
                </Col>
              </Row>
            </div>
          </Col>
          <Col lg={{ span: 4, offset: 1 }}>
            <img className='contact__image' alt='' src={Images.menu} />
          </Col>
        </Row>
        <Row className='mt-5'>
          <Col xs={12} lg={6}>
            <h3>House Of Arie 1</h3>
            <iframe
              title="House Of Arie 1 Location"
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15864.003009199201!2d106.7644129!3d-6.2636295!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x9b9696c7a2fa90a5!2sHouse%20of%20Arie!5e0!3m2!1sen!2sid!4v1597990641382!5m2!1sen!2sid"
              height="450"
              frameBorder="0"
              style={{ border: 0, width: '100%' }}
              allowFullScreen=""
              aria-hidden="false"
              tabIndex="0"
            />
          </Col>
          <Col xs={12} lg={6}>
            <h3>House Of Arie 2</h3>
            <iframe
              title="House Of Arie 2 Location"
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15864.003009199201!2d106.7644129!3d-6.2636295!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x9b9696c7a2fa90a5!2sHouse%20of%20Arie!5e0!3m2!1sen!2sid!4v1597990641382!5m2!1sen!2sid"
              height="450"
              frameBorder="0"
              style={{ border: 0, width: '100%' }}
              allowFullScreen=""
              aria-hidden="false"
              tabIndex="0"
            />
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default ContactInfo;
